import React from 'react';
import Wrapper from './styles';

interface Props {
    selectedOutcomesCount: number;
    requiredSelections: number;
}
export default function SportContestsBetslipCounter({ selectedOutcomesCount, requiredSelections }: Props) {
    return (
        <Wrapper>
            {selectedOutcomesCount} / {requiredSelections}
        </Wrapper>
    );
}
